module.exports = __webpack_public_path__ + "img/email.1556fa4.png";